module.exports = __webpack_public_path__ + "static/media/avatarman.3efc9d5b.png";